function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientTransform: "matrix(1 0 0 -1 -561.6 -8714.989)",
  gradientUnits: "userSpaceOnUse",
  x1: 863.508,
  x2: 755.497,
  y1: -8660.016,
  y2: -9365.088
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffd9d9",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9981,
  stopColor: "#ffb3b3"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 255.999,
  x2: 255.999,
  y1: 304.698,
  y2: 84.804
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ff4d4d",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff4d4d",
  stopOpacity: 0
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m338.919 70.183c-1.369 0-2.734.012-4.096.037-33.932.616-66.631-11.72-93.007-33.075-23.389-18.936-53.236-30.21-85.724-29.998-74.135.484-135.234 63.074-134.007 137.2.33 19.96 4.996 38.864 13.096 55.813 13.801 28.879 10.825 63.235-8.352 88.861-7.92 10.584-14.402 22.515-19.061 35.605-24.826 69.757 11.848 147.296 81.551 172.272 70.982 25.434 148.823-12.162 173.19-83.256 1.805-5.266 3.265-10.567 4.393-15.878 7.162-33.729 36.586-57.876 71.067-57.732.317.001.634.002.951.002 95.59 0 173.08-60.408 173.08-134.925s-77.492-134.926-173.081-134.926z",
  fill: "url(#SVGID_1_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m376.999 308.612h-3v-3c0-2.762-2.238-5-5-5s-5 2.238-5 5v3h-3c-2.762 0-5 2.238-5 5s2.238 5 5 5h3v3c0 2.762 2.238 5 5 5s5-2.238 5-5v-3h3c2.762 0 5-2.238 5-5s-2.238-5-5-5z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m101.406 269.095h-3v-3c0-2.762-2.238-5-5-5s-5 2.238-5 5v3h-3c-2.762 0-5 2.238-5 5s2.238 5 5 5h3v3c0 2.762 2.238 5 5 5s5-2.238 5-5v-3h3c2.762 0 5-2.238 5-5s-2.238-5-5-5z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m319.784 32.123h-3v-3c0-2.762-2.238-5-5-5s-5 2.238-5 5v3h-3c-2.762 0-5 2.238-5 5s2.238 5 5 5h3v3c0 2.762 2.238 5 5 5s5-2.238 5-5v-3h3c2.762 0 5-2.238 5-5s-2.238-5-5-5z",
  fill: "#ff9d33"
}), /*#__PURE__*/React.createElement("path", {
  d: "m418.592 306.504c-1.279 0-2.56-.488-3.535-1.465l-4.465-4.464-4.465 4.464c-1.951 1.953-5.119 1.953-7.07 0-1.953-1.952-1.953-5.118 0-7.07l8-8c1.951-1.953 5.119-1.953 7.07 0l8 8c1.953 1.952 1.953 5.118 0 7.07-.976.977-2.256 1.465-3.535 1.465z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m109.406 362.025c-1.279 0-2.56-.488-3.535-1.465l-4.465-4.464-4.465 4.464c-1.951 1.953-5.119 1.953-7.07 0-1.953-1.952-1.953-5.118 0-7.07l8-8c1.951-1.953 5.119-1.953 7.07 0l8 8c1.953 1.952 1.953 5.118 0 7.07-.975.977-2.255 1.465-3.535 1.465z",
  fill: "#ff9d33"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#2626bc"
}, /*#__PURE__*/React.createElement("path", {
  d: "m87.666 89.808c-8.271 0-15 6.729-15 15v12.333h10v-12.333c0-2.757 2.243-5 5-5h66.333v-10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m139.604 225.594c-14.781 0-28.251-5.677-38.382-14.947l-4.061-3.456-8.482 4.745 3.418 3.817c12.136 12.242 28.948 19.842 47.508 19.842h15.025v-10.001z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m429.332 104.808v12.332h10v-12.332c0-8.271-6.729-15-15-15h-66.333v10h66.333c2.757 0 5 2.243 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m410.776 210.647c-10.129 9.273-23.6 14.948-38.382 14.948h-14.852v10.001h14.851c18.559 0 35.364-7.605 47.498-19.848l3.84-3.866-9.1-5.091z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m282.156 304.698h-52.315c-41.887 0-75.843-33.956-75.843-75.843v-144.051h204v144.051c.001 41.887-33.955 75.843-75.842 75.843z",
  fill: "#ffc599"
}), /*#__PURE__*/React.createElement("path", {
  d: "m153.999 84.804h204v30.003h-204z",
  fill: "#ff9d33"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 255.999,
  cy: 188.751,
  fill: "#ff7300",
  r: 65.971
}), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m255.999 240.144c-28.338 0-51.393-23.055-51.393-51.393s23.055-51.393 51.393-51.393 51.393 23.055 51.393 51.393-23.055 51.393-51.393 51.393zm0-92.786c-22.824 0-41.393 18.568-41.393 41.393s18.568 41.393 41.393 41.393 41.393-18.568 41.393-41.393-18.569-41.393-41.393-41.393z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m255.999 240.144c-16.433 0-25.3-26.479-25.3-51.393s8.867-51.393 25.3-51.393 25.3 26.479 25.3 51.393-8.867 51.393-25.3 51.393zm0-92.786c-6.238 0-15.3 16.125-15.3 41.393 0 11.718 1.963 22.656 5.526 30.8 2.858 6.534 6.604 10.593 9.773 10.593 6.238 0 15.3-16.125 15.3-41.393 0-11.718-1.963-22.656-5.526-30.8-2.858-6.534-6.603-10.593-9.773-10.593z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m255.999 179.119c-16.36 0-31.757-3.646-41.187-9.754-2.318-1.501-2.98-4.597-1.479-6.914s4.598-2.981 6.914-1.479c7.877 5.101 21.241 8.146 35.751 8.146 14.5 0 28.301-3.188 36.017-8.321 2.301-1.529 5.404-.904 6.933 1.394 1.529 2.3.905 5.403-1.394 6.933-9.409 6.259-24.943 9.995-41.555 9.995z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m217.103 217.619c-1.61 0-3.19-.776-4.155-2.213-1.54-2.292-.93-5.398 1.362-6.938 9.4-6.314 24.985-10.085 41.689-10.085 16.36 0 31.757 3.646 41.187 9.754 2.318 1.501 2.98 4.597 1.479 6.914s-4.598 2.981-6.914 1.479c-7.877-5.101-21.241-8.146-35.751-8.146-14.575 0-28.413 3.213-36.113 8.386-.857.574-1.826.849-2.784.849z"
})))), /*#__PURE__*/React.createElement("path", {
  d: "m370.666 94.808h-229.334c-2.761 0-5-2.239-5-5v-15.334c0-2.761 2.239-5 5-5h229.333c2.761 0 5 2.239 5 5v15.333c.001 2.762-2.238 5.001-4.999 5.001z",
  fill: "#ffe8dc"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m427.115 214.059-13.963-7.812c-2.41-1.348-3.271-4.395-1.922-6.805l3.906-6.982c4.054-7.245 6.196-15.477 6.196-23.804v-46.516c0-2.761 2.239-5 5-5h16c2.761 0 5 2.239 5 5v46.516c0 12.762-3.287 25.383-9.507 36.499l-3.905 6.981c-1.349 2.41-4.395 3.271-6.805 1.923z",
  fill: "#ffc599"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m84.883 214.059c-2.41 1.348-5.457.488-6.805-1.922l-3.905-6.981c-6.22-11.116-9.507-23.737-9.507-36.499v-46.516c0-2.761 2.239-5 5-5h16c2.761 0 5 2.239 5 5v46.516c0 8.327 2.143 16.559 6.196 23.804l3.906 6.982c1.348 2.41.488 5.457-1.922 6.805z",
  fill: "#ffc599"
})))), /*#__PURE__*/React.createElement("path", {
  d: "m227.16 304.698h56.257v31.161h-56.257z",
  fill: "#ff6c6c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m227.16 304.698h56.257v17.828h-56.257z",
  fill: "#ff4d4d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m311.784 370.192-28.367-34.333h-56.257l-28.367 34.333z",
  fill: "#ff7300"
}), /*#__PURE__*/React.createElement("path", {
  d: "m363.999 448.526h-216c-2.761 0-5-2.239-5-5v-53.333c0-11.046 8.954-20 20-20h186c11.046 0 20 8.954 20 20v53.333c0 2.761-2.239 5-5 5z",
  fill: "#ffc599"
}), /*#__PURE__*/React.createElement("path", {
  d: "m282.156 304.698h-52.315c-41.887 0-75.843-33.956-75.843-75.843v-144.051h204v144.051c.001 41.887-33.955 75.843-75.842 75.843z",
  fill: "url(#SVGID_2_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m327.999 426.526h-144c-2.761 0-5-2.239-5-5v-23.333c0-2.761 2.239-5 5-5h144c2.761 0 5 2.239 5 5v23.333c0 2.761-2.239 5-5 5z",
  fill: "#8383ff"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m292.759 414.859h-73.52c-2.762 0-5-2.239-5-5s2.238-5 5-5h73.52c2.762 0 5 2.239 5 5s-2.239 5-5 5z",
  fill: "#fff"
}))))));

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.d06eaca9.svg";
export { ForwardRef as ReactComponent };